module.exports = __webpack_public_path__ + "img/hr-steam-engine-V.544bb14d.png";